import React from "react";
import { IForm } from "../../../../types/form.type";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../input/TextInput";
import { useForm } from "react-hook-form";
import ModalForm from "../../modal/ModalForm";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import { useSelector } from "react-redux";

function FormIDThuoc({
  defaultValues,
  isEdit,
  apiCode,
  open,
  freeMode,
  title,
  onClose,
  setLoad,
}: IForm) {
  const token = useSelector((state: any) => state.auth.token);
  const defaultData = {
    id: "",
    ten_moi_thau: "",
    ham_luong: "",
    bao_che: "",
    duong_dung: "",
    don_vi: "",
    nhom: "",
  };
  const originData = !!defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
      }
    : defaultData;
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
  });

  const handleSave = async (values: typeof defaultData) => {
    try {
      if (isEdit) {
        await asyncPutData({
          id: defaultValues?._id,
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      } else {
        await asyncPostData({
          apiCode,
          token,
          applyToken: true,
          withIdApp: true,
          data: values,
        });
      }
      onClose();
      setLoad?.((prev: number) => prev + 1);
    } catch (error: any) {
      alert(error?.error || error?.message || "Lưu không thành công");
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="1000px"
      formTitle="ID Thuốc"
      title={title}
      open={open}
      onClose={onClose}
      isEdit={isEdit}
      onSubmit={onSubmit}
      loading={isSubmitting}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline={false}
              label="ID (BV)"
              id="id"
              labelWidth="25%"
              placeholder="Nhập ID"
              name="id"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Tên mời thầu"
              id="ten_moi_thau"
              labelWidth="25%"
              placeholder="Nhập tên mời thầu"
              name="ten_moi_thau"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Hàm lượng"
              id="ham_luong"
              labelWidth="25%"
              placeholder="Hàm lượng"
              name="ham_luong"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Dạng bào chế"
              id="bao_che"
              labelWidth="25%"
              placeholder="Nhập dạng bào chế"
              name="bao_che"
              register={register}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Đường dùng"
              id="duong_dung"
              labelWidth="25%"
              placeholder="Nhập đường dùng"
              name="duong_dung"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Đơn vị tính"
              id="don_vi"
              labelWidth="25%"
              placeholder="Nhập đơn vị tính"
              name="don_vi"
              register={register}
            />
            <TextInput
              // readOnly={!freeMode}
              multiline
              label="Nhóm thuốc"
              id="nhom"
              labelWidth="25%"
              placeholder="Nhập nhóm thuốc"
              name="nhom"
              register={register}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </ModalForm>
  );
}

export default FormIDThuoc;
